// Certify's tier-denied takeover (docs/design/slice4-certify-ux.md §2.3 "Below Studio
// (Solo)"): reuses `RefusalCard.tsx`'s COMPOSITION (`.card.state-card.refusal`,
// `.actions`, never a blocking modal - `modal-escape`/`escape-routes`) rather than that
// component's `AppLimitRefusal`-specific props, since Certify's refusal carries no
// app-limit figures - two real ways forward, NEVER a price (D27/D58), and "Back to your
// apps" always works. `stageDenied` renders the secondary stage note beneath the tier
// refusal when BOTH gates apply at once (§2.3 "the tier refusal takes visual
// precedence... the stage note appears as a secondary line beneath it").
import { Link } from "react-router-dom";
import { certifyCopy } from "../copy/certify.js";

export const CertifyTierRefusalCard = ({
  appName,
  stageDenied,
  onAskAboutUpgrading,
}: {
  readonly appName: string;
  readonly stageDenied?: boolean;
  readonly onAskAboutUpgrading: () => void;
}): React.JSX.Element => (
  <div className="card state-card refusal" role="region" aria-label="Certify requires Studio">
    <div className="h3">{certifyCopy("certify.empty.notEntitled.heading")}</div>
    <p className="muted">{certifyCopy("certify.empty.notEntitled.body", { appName })}</p>
    {stageDenied === true ? (
      <p className="muted" style={{ fontSize: 12.5 }}>
        {certifyCopy("certify.stageGate.heading", { appName })}
      </p>
    ) : null}
    <div className="actions">
      <button type="button" className="btn btn-primary" onClick={onAskAboutUpgrading}>
        {certifyCopy("certify.empty.notEntitled.cta")}
      </button>
    </div>
    <Link className="btn btn-ghost btn-sm" to="/apps">
      Back to your apps
    </Link>
  </div>
);
